import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import TopicNews from './topicNews';
import ExtraNews from './extraNews/';

class DateNews extends React.PureComponent {
    static propTypes = {
        dayMainNew0: PropTypes.array,
        dayMainNew1: PropTypes.array,
        extraNews: PropTypes.string,
        extraNewsAd: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { dayMainNew0, dayMainNew1, extraNews, extraNewsAd } = this.props;

        return (
            <div className={styles.box}>
                <div className={styles.newList}>
                    <div className={styles.list_top}>
                        <Chip
                            id="75007"
                            type="recommend"
                            title="今日要闻列表一"
                            groupName="正文"
                            content={dayMainNew0}
                            translate="handleHeadlinePicData">
                            <TopicNews />
                        </Chip>
                    </div>
                    <div className={styles.list_middle}>
                        <Chip
                            id="165042"
                            type="recommend"
                            title="今日要闻列表二"
                            groupName="正文"
                            content={dayMainNew1}
                            translate="handleHeadlinePicData">
                            <TopicNews />
                        </Chip>
                    </div>
                </div>
                <NoSSR>
                    <Chip
                        id="10011"
                        type="static"
                        title="今日要闻多拼静态碎片"
                        groupName="正文"
                        position="relative"
                        content={extraNews}>
                        <ExtraNews content={extraNews} extraNewsAd={extraNewsAd} />
                    </Chip>
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(DateNews);
